import { styled } from '@mui/system'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { Box, Button, Card, Checkbox, FormControlLabel, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CircleIcon from '@mui/icons-material/Circle'

export const EditIconStyle = styled(EditIcon)(({ theme }) => ({
  color: theme.palette.button.edit.primary,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '8px',
  cursor: 'pointer',
  '& :hover': {
    color: theme.palette.button.edit.hover
  }
}))

export const DeleteIconStyle = styled(DeleteIcon)(({ theme }) => ({
  color: `${theme.palette.button.delete.primary}`,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '6px',
  cursor: 'pointer',
  '& :hover': {
    color: theme.palette.button.delete.hover
  }
}))

export const CheckboxStyle = styled(Checkbox)(({ theme, checked }) => {
  let backgroundColor = 'black !important'
  let fill = 'black !important'
  if (checked) {
    backgroundColor = '#9999FF !important'
    fill = '#9999FF !important'
  }
  return {
    margin: 0,
    padding: 0,
    '& .MuiSvgIcon-root': {
      color: `${theme.palette.separators.primary} !important`,
      backgroundColor: `${theme.palette.separators.primary} !important`,
      border: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      color: `${theme.palette.button.save.primary} !important`,
      borderColor: `${theme.palette.button.save.primary} !important`,
      borderRadius: '2px'
    },
    '&.Mui-disabled .MuiSvgIcon-root path': {
      color: 'black',
      backgroundColor: backgroundColor,
      borderColor: `${theme.palette.button.save.primary}`,
      borderRadius: '2px',
      fill: fill
    }
  }
})

export const CheckboxStyle2 = styled(Checkbox)(({ theme, checked }) => {
  let backgroundColor = 'black !important'
  let fill = 'black !important'
  if (checked) {
    backgroundColor = '#9999FF !important'
    fill = '#9999FF !important'
  }
  return {
    margin: 0,
    padding: 0,
    '& .MuiSvgIcon-root': {
      color: '#242428',
      backgroundColor: '#242428',
      border: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      color: `${theme.palette.button.save.primary} `,
      borderColor: `${theme.palette.button.save.primary}`,
      borderRadius: '2px'
    },
    '&.Mui-disabled .MuiSvgIcon-root path': {
      color: 'black',
      backgroundColor,
      borderColor: `${theme.palette.button.save.primary}`,
      borderRadius: '2px',
      fill: fill
    }
  }
})

export const FormControlLabelStyle = styled(FormControlLabel)({
  marginLeft: '0px',
  marginRight: '0px'
})

export const TypographyDisabled = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.separators.primary,
  color: `${theme.palette.text.primary} !important`,
  borderRadius: '5px',
  height: '30px',
  padding: '5px'
}))

export const CheckIconStyle = styled(CheckIcon)(({ theme, isactive }) => {
  let display = 'none'
  if (+isactive === 1) {
    display = 'block'
  }
  return {
    display,
    width: '100%',
    marginTop: '5px',
    color: theme.palette.button.save.primary
  }
})

export const CircleIconStyle = styled(CircleIcon)(({ theme, isactive }) => {
  let color = theme.palette.switch.unactive
  if (+isactive === 1) {
    color = theme.palette.switch.active
  }

  return {
    color,
    width: '12px',
    height: '12px'
  }
})

export const MyCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.card.primary,
  paddingTop: '40px',
  paddingLeft: '48px',
  paddingRight: '48px',
  paddingBottom: '40px',
  borderRadius: '12px',
  [theme.breakpoints.down('md')]: {
    height: '100dvh',
    width: '100dvw'
  },
  '& .MuiCardContent-root': {
    padding: '0px !important'
  }
}))

export const CardTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Nunito',
  textAlign: 'center',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal'
}))

export const CardText = styled(Typography)(({ theme }) => ({
  color: theme.palette.svg.clearIcon,
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Nunito',
  textAlign: 'center',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal'
}))

export const Row = styled(Box)(() => ({
  display: 'flex'
}))

export const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  color: 'black',
  padding: '11px 24px',
  fontFamily: 'Nunito',
  textTransform: 'capitalize',
  height: '32px',
  fontSize: '14px',
  fontWeight: 700,
  backgroundColor: theme.palette.button.cancel.primary,
  '&:hover': {
    backgroundColor: theme.palette.button.cancel.hover
  }
}))

export const SaveChangesButton = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  color: 'black',
  padding: '11px 24px',
  fontFamily: 'Nunito',
  fontSize: '14px',
  textTransform: 'capitalize',
  height: '32px',
  fontWeight: 700,
  backgroundColor: theme.palette.button.save.primary,
  '&:hover': {
    backgroundColor: theme.palette.button.save.hover
  },
  '&:disabled': {
    background: `${theme.palette.button.disable} !important`,
    color: theme.palette.svg.clearIcon
  }
}))

export const ButtonAddNew = styled(Button)(({ theme }) => ({
  background: theme.palette.button.addNew.primary,
  padding: '11px 24px',
  fontFamily: 'Nunito',
  height: '32px',
  fontSize: '14px',
  textTransform: 'capitalize',
  fontWeight: 700,
  color: `${theme.palette.tabs.backgroundColor.primary}`,
  '&:hover': {
    backgroundColor: theme.palette.button.addNew.hover
  },
  '&.Mui-disabled': {
    background: `${theme.palette.button.disable} !important`,
    color: theme.palette.svg.clearIcon
  }
}))

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '12px',
  marginBottom: '4px',
  textTransform: 'capitalize',
  width: 'max-content'
}))
